import React from 'react';

function RateScheduleIcon({ fill, className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill={`${fill}`}
    >
      {/* Calendar Frame */}
      <rect
        x="10"
        y="16"
        width="44"
        height="36"
        rx="4"
        ry="4"
        stroke="black"
        strokeWidth="2"
        fill="none"
      />

      {/* Top Bar of the Calendar */}
      <rect x="10" y="10" width="44" height="8" fill="black" />

      {/* Left and Right Calendar Hooks */}
      <rect x="16" y="4" width="6" height="10" rx="2" ry="2" fill="black" />
      <rect x="42" y="4" width="6" height="10" rx="2" ry="2" fill="black" />

      {/* Dollar Sign */}
      <text x="23" y="36" fontSize="16" fontWeight="bold" fill="black">
        $
      </text>

      {/* Clock Icon */}
      <circle
        cx="45"
        cy="40"
        r="10"
        stroke="black"
        strokeWidth="2"
        fill="none"
      />
      <line x1="45" y1="40" x2="45" y2="34" stroke="black" strokeWidth="2" />
      <line x1="45" y1="40" x2="48" y2="42" stroke="black" strokeWidth="2" />
    </svg>
  );
}

export default RateScheduleIcon;
